import { HYPEREXECUTE_BASE, TMS_CLIENT_BASE } from '../config';

/** TC-id deep link: project + test-case id → the TMS test-case dashboard
 * (TMS handles login → redirect-back when opened signed-out). Older packs
 * without those ids fall back to the legacy sharable_link. */
export function testCaseHref(projectId, testcaseId, sharableLink) {
  if (projectId && testcaseId) {
    return "".concat(TMS_CLIENT_BASE, "/projects/").concat(projectId, "/test-cases/").concat(testcaseId, "/dashboard");
  }
  return sharableLink !== null && sharableLink !== void 0 ? sharableLink : null;
}

/** "HyperExecute" link — external_id.hyper_job_id → the task page. */
export function hyperExecuteHref(jobId) {
  return jobId ? "".concat(HYPEREXECUTE_BASE, "/hyperexecute/task?jobId=").concat(jobId) : null;
}